import React, { useRef, useState } from "react";
import { Breadcrumb } from "../../Utils/helper";
import styles from "./BulkUpload.module.css";
import { useLocation, useNavigate } from "react-router-dom";

const BulkUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [droppedFileName, setDroppedFileName] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const location=useLocation();

  const navigate = useNavigate();
  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setDroppedFileName(file.name);
    }
  };

  const handleUpload = () => {
    fileInputRef.current.click();
  };

  const handleInputClick = (event) => {
    event.stopPropagation();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setSelectedFile(droppedFile);
      setDroppedFileName(droppedFile.name);
    }
  };
  var headerPos = 4;
  // if((useLocation().pathname).includes('BulkUpload')){
  //   headerPos = 4;
  // }
  const handlebtn1 = () => {
    navigate('/');
  };
  const handleDownload=()=>{
    navigate('/Bulkupload/Fixerrors')
  }
  return (
    <>
      <div className={styles.companyProfile}>
        <Breadcrumb/>
      </div>
      <div className={styles.companyHeader}>
        <main className={styles.frameSupportingText}>
          <section className={styles.h1Parent}>
            <div className={styles.heading}>
              <div className={styles.heading}>
              <div className={styles.button} onClick={() => navigate(-1)}>
                  <img
                    className={styles.arrowLeftIcon}
                    loading="eager"
                    alt=""
                    src="/arrowleft.svg"
                  />
                </div>
                <div className={styles.text}>
                  <h2 className={styles.navitem}>Upload Bulk sheet</h2>
                </div>
                <div className={styles.optionsBtn}>
                  <div className={styles.Option}>
                    <div
                      className={styles.btn1}
                      onClick={() =>handlebtn1()}
                    >
                      Go to Manual Upload
                    </div>
                    <div
                      className={styles.btn2}
                      onClick={() => alert("upload Bulk")}
                    >
                      <div>
                        <img
                          className={styles.uploadOutlineIcon}
                          alt=""
                          src="/uploadBulk.svg"
                          style={{ width: "15px", paddingRight: "7px" }}
                        />
                      </div>
                      <div style={{fontWeight:"600"}}>Upload Bulk List</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <div className={styles.dragContainer}>
        <div className={styles.dragH1}>
          <div
            className={`${styles.fileUploadBox} ${isDragging ? styles.dragover : ''}`}
            onClick={handleBoxClick}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
              // accept=".csv,.xls"
              onClick={handleInputClick}
            />
            {droppedFileName || selectedFile ? (
              <p style={{ fontWeight: "600" }}>Selected File: {droppedFileName || selectedFile.name}</p>
            ) : (
              <div className={styles.dragContent}>
                <img src="uploadoutline.svg" alt="upload icon" />
                <p style={{ fontWeight: "700" }}>Upload a XLS/CSV with recipients' data from your computer</p>
                <p style={{ color: "Gray" }}>{`CSV, XLSX, and XLS (Max.5mb)`}</p>
              </div>
            )}
          </div>
          <div className={styles.buttonContainer}>
            <div className={styles.btn3} onClick={() =>handleDownload()}>
              <div>
                <img
                  className={styles.uploadOutlineIcon}
                  alt=""
                  src="/downloadUpload.svg"
                  style={{ width: "15px", paddingRight: "7px" }}
                />
              </div>
              <div style={{ fontWeight: "500", padding: "1px" }}>Download Bulk Template</div>
            </div>
            <div className={styles.btn4}>
              <div>
                <img
                  className={styles.uploadOutlineIcon}
                  alt=""
                  src="/uploadBulk.svg"
                  style={{ width: "15px", paddingRight: "7px" }}
                />
              </div>
              <div style={{ fontWeight: "500", padding: "1px" }}onClick={handleUpload}>Upload Bulk List</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkUpload;
